<template>
  <div class="content">
    <div class="layout">
      <div class="text-end mb-3">
        <select
          v-model="selectedLang"
          @change="onLangChange"
          class="form-select w-auto d-inline-block"
        >
          <option v-for="lang in languages" :key="lang.code" :value="lang.code">
            {{ lang.language }}
          </option>
        </select>
        <select
          v-model="selectedCountry"
          @change="onCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
      </div>

      <div>
        <div class="justify-content-center text-center">
          <div style="width: 100%">
            <div class="text-end mb-2">
              <button class="btn btn-success" @click="addLink">Add Link</button>
            </div>
            <div style="overflow-x: auto">
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Name</th>
                    <!-- <th scope="col">Icon</th> -->
                    <th scope="col">Links</th>
                    <th scope="col"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(social, index) in socialmedia"
                    :key="index"
                    class="align-items-center"
                  >
                    <td
                      class="p-1 px-2 align-content-center text-center"
                      style="font-weight: bold"
                    >
                      {{ social.name }}
                    </td>
                    <!-- <td class="p-1 px-2 align-content-center text-center">
                      <img
                        v-if="social.icon"
                        :src="getBannerUrl(social.icon)"
                        class="icon-preview"
                        alt="icon"
                      />
                    </td> -->
                    <td class="p-1 px-2 align-content-center text-start">
                      {{ social.link }}
                    </td>
                    <td class="text-end p-1 align-content-center">
                      <!-- Update Button -->
                      <!-- <button
                        class="btn btn-warning"
                        @click="updateLink(social)"
                      >
                        Update
                      </button> -->
                      <!-- Delete Button -->
                      <button
                        class="btn btn-danger"
                        @click="deleteLink(social.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Modal for Adding a New Link -->
        <div v-if="showModal" class="modal-overlay">
          <div class="modal-content">
            <div class="text-end">
              <button
                class="btn-close text-end btn btn-danger custom-close"
                data-bs-theme="light"
                style="--bs-close-color: red"
                @click="showModal = false"
              ></button>
            </div>
            <div class="modal-header">
              <h2>Add Link</h2>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addSocialM" enctype="multipart/form-data">
                <div class="mb-2">
                  <select
                    v-model="selectedPlatform"
                    class="form-select"
                    required
                  >
                    <option value="" disabled>Select Social Media</option>
                    <option
                      v-for="platform in platforms"
                      :key="platform.key"
                      :value="platform"
                    >
                      {{ platform.label }}
                    </option>
                  </select>
                </div>

                <div class="mb-2">
                  <input
                    type="text"
                    id="link"
                    v-model="link"
                    placeholder="Link"
                    class="form-control"
                    required
                  />
                </div>

                <!-- File upload for icon -->
                <!-- <div class="text-start mb-1 mt-3">Upload icon</div>
                <div class="mb-1">
                  <input
                    type="file"
                    id="icon"
                    @change="handleIconUpload"
                    class="form-control"
                    required
                  />
                   Display icon if uploaded  -->
                <!-- <div v-if="iconPreview"> -->
                <!-- <img
                      :src="iconPreview"
                      alt="Uploaded Icon"
                      class="icon-preview"
                    />
                  </div> -->
                <!-- </div> -->

                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">
                    <span v-if="loading">Loading...</span
                    ><span v-else>Add Link</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Modal for Updating a Link -->
        <div v-if="updateShowModal" class="modal-overlay">
          <div class="modal-content">
            <div class="text-end">
              <button
                class="btn-close text-end btn btn-danger custom-close"
                data-bs-theme="light"
                style="--bs-close-color: red"
                @click="updateShowModal = false"
              ></button>
            </div>
            <div class="modal-header">
              <h2>Update Link</h2>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateSocialM">
                <div class="mb-2">
                  <select
                    v-model="selectedPlatform"
                    class="form-select"
                    required
                  >
                    <option value="" disabled>Select Social Media</option>
                    <option
                      v-for="platform in platforms"
                      :key="platform.key"
                      :value="platform"
                    >
                      {{ platform.label }}
                    </option>
                  </select>
                </div>

                <div class="mb-2">
                  <input
                    type="text"
                    id="link"
                    v-model="link"
                    placeholder="Link"
                    class="form-control"
                    required
                  />
                </div>

                <!-- File upload for icon -->
                <!-- <div class="text-start mb-1 mt-3">Upload icon</div>
                <div class="mb-1">
                  <input
                    type="file"
                    id="icon"
                    @change="handleIconUpload"
                    class="form-control" -->
                <!-- /> -->
                <!-- Display icon if uploaded -->
                <!-- <div v-if="iconPreview" class="text-center"> -->
                <!-- <img
                      :src="iconPreview"
                      alt="Uploaded Icon"
                      class="icon-preview mt-2"
                    /> -->
                <!-- </div> -->
                <!-- </div> -->

                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">
                    <span v-if="loading">Loading...</span
                    ><span v-else>Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      socialmedia: [],
      selectedPlatform: "", // 👈 selected social media key
      link: "",
      name: "",

      platforms: [
        { key: "facebook", label: "Facebook" },
        { key: "twitter", label: "Twitter / X" },
        { key: "instagram", label: "Instagram" },
        { key: "tiktok", label: "TikTok" },
        { key: "youtube", label: "YouTube" },
        { key: "telegram", label: "Telegram" },
        { key: "whatsapp", label: "WhatsApp" },
        { key: "linkedin", label: "LinkedIn" },
        { key: "snapchat", label: "Snapchat" },
        { key: "discord", label: "Discord" },
        { key: "threads", label: "Threads" },
        { key: "website", label: "Website" },
      ],

      showModal: false,
      loading: false,
      selectedLang: "en",
      selectedCountry: "CG",
      languages: [],
      countries: [],
    };
  },
  watch: {
    selectedLang(newLang) {
      this.getLinks(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.getLinks(this.selectedLang, newCountry);
    },
  },
  methods: {
    getBannerUrl(url) {
      if (url && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    onLangChange() {
      this.getLinks(this.selectedLang, this.selectedCountry);
    },

    updateLink(social) {
      this.name = social.name;
      this.link = social.link;
      this.iconPreview = social.icon;
      this.updateId = social.id;
      this.updateShowModal = true;
    },

    handleIconUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.iconPreview = URL.createObjectURL(file);
        this.iconFile = file;
      }
    },

    // Show the modal for adding a new link
    addLink() {
      this.showModal = true;
    },

    // Add a new social media link
    async addSocialM() {
      if (!this.selectedPlatform) {
        this.$notify({
          message: "Please select a social media platform",
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        return;
      }

      const formData = new FormData();
      formData.append("name", this.selectedPlatform.key); // 👈 auto name
      formData.append("link", this.link);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);

      try {
        this.loading = true;
        const response = await axios.post("/smhandles", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 201) {
          this.$notify({
            message: "Link added successfully",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.getLinks(this.selectedLang, this.selectedCountry);
        this.loading = false;
        this.showModal = false;

        // reset
        this.selectedPlatform = "";
        this.link = "";
      }
    },

    // Update an existing social media link
    async updateSocialM() {
      const formData = new FormData();
      formData.append("name", this.selectedPlatform.key);
      formData.append("link", this.link);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);
      if (this.iconFile) {
        formData.append("file", this.iconFile);
      }

      try {
        this.loading = true;
        const response = await axios.post(
          `/smhandles/${this.updateId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "api-key": Cookies.get("authToken"),
            },
          }
        );

        if (response.status === 200) {
          this.$notify({
            message: "Link updated successfully",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.getLinks(this.selectedLang, this.selectedCountry);
          this.updateShowModal = false;
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.selectedPlatform = "";
        this.link = "";
        this.loading = false;
      }
    },
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    // async getCountries() {
    //   try {
    //     const response = await axios.get(`countries`, {
    //       headers: {
    //         "api-key": `${Cookies.get("authToken")}`,
    //       },
    //     });
    //     if (response.status === 200 && Array.isArray(response.data.countries)) {
    //       this.countries = response.data.countries;
    //     } else {
    //       this.countries = [];
    //     }
    //   } catch (error) {
    //     this.handleError(error);
    //   }
    // },
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    async getLinks(lang, country) {
      try {
        const response = await axios.get(
          `/smhandles?lang=${lang}&country=${country}`,
          {
            headers: { "api-key": Cookies.get("authToken") },
          }
        );
        this.socialmedia = response.data.socialMedia;
      } catch (error) {
        this.handleError(error);
      }
    },

    async deleteLink(id) {
      try {
        const response = await axios.delete(`/smhandles/${id}`, {
          headers: { "api-key": Cookies.get("authToken") },
        });
        if (response.status === 200) {
          this.$notify({
            message: "Successfully deleted",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.getLinks(this.selectedLang, this.selectedCountry);
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      if (error.status == 401) {
        this.$notify({
          message: "Session expired, please login",
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else if (error.status == 404) {
        this.$notify({
          message: error.response.data.error_message,
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.$notify({
          message:
            error.response.data.error_message || error.response.data.message,
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      }
    },
  },
  mounted() {
    this.getLanguages();
    // this.getLinks();
    this.getCountries();
    if (!this.selectedCountry && this.countries.length) {
      this.selectedCountry = this.countries[0].code;
    }
    this.getLinks(this.selectedLang, this.selectedCountry);
  },
};
</script>
